import styled from 'styled-components';

const ClickableStyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  padding: ${(props) => props.padding}px;

  .Clickable {
  }
`;

export { ClickableStyled as default };
//# sourceMappingURL=bundle.esm2.js.map
